// Shared utility for check-level verification result color coding
// Used in: OperationsManagerDashboard, AgentInternalVendorDashboard, VendorManagementDashboard, VendorDashboard

export const getResultTextColor = (result) => {
  if (!result) return '';
  switch (result) {
    case 'major_discrepancy':
    case 'discrepancy':
    case 'red':
      return 'text-red-600';
    case 'minor_discrepancy':
      return 'text-rose-500';
    case 'unable_to_verify':
    case 'amber':
      return 'text-amber-600';
    case 'clear':
    case 'green':
      return 'text-emerald-600';
    default:
      return 'text-gray-500';
  }
};

export const getResultLabel = (result) => {
  if (!result) return '';
  switch (result) {
    case 'major_discrepancy': return 'Major Discrepancy';
    case 'minor_discrepancy': return 'Minor Discrepancy';
    case 'unable_to_verify': return 'Unable to Verify';
    case 'discrepancy': return 'Discrepancy';
    case 'clear': return 'Clear';
    case 'red': return 'Discrepancy';
    case 'amber': return 'Unable to Verify';
    case 'green': return 'Clear';
    default: return result.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  }
};

// Returns true if the result should be highlighted below the Completed badge
export const shouldShowResult = (result) => {
  if (!result || result === 'pending') return false;
  return true;
};
